import * as axios from 'axios';
import { getAuthHeader } from '../utils';

export const getList = (loanDetailId: any, empView: boolean) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v1/chat/list?ldid=${loanDetailId}&emp=${empView}`;
    return axios.get(url, getAuthHeader()).then((response: any) => {
        return response.data;
    });
}

export const addDetail = (model: any) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v1/chat/add`;
    return axios.post(url, model, getAuthHeader())
        .then((response: any) => {
            return response.data;
        });
}